import React, { useState, useEffect, useCallback } from 'react'
import { Container, Row } from 'react-bootstrap'
import { StyledDatePicker, StyledInput, CalendarIcon, Wrapper } from './DateRangePicker.style'
import {
  DATE_APP_FORMAT,
  DATE_DATA_FORMAT,
  DATE_MOMENT_DATA_FORMAT,
} from 'utils/constants'
import moment from 'moment'
import { forwardRef } from 'react'
import { FaRegCalendarAlt } from 'react-icons/fa'
import DatePicker from 'react-datepicker'

const FromToRange = ({ range, onChange }) => {
  const [from, to] = range
  const [dateFrom, setDateFrom] = useState(
    from ? Date.parse(`${from}T00:00:00`) : null
  )
  const [dateTo, setDateTo] = useState(to ? Date.parse(`${to}T00:00:00`) : null)

  useEffect(() => {
    setDateTo(to ? Date.parse(`${to}T00:00:00`) : null)
    setDateFrom(from ? Date.parse(`${from}T00:00:00`) : null)
  }, [from, to])

  const handleDateChange = useCallback(
    ([dateFrom, dateTo]) => {
      const from = dateFrom ? moment(dateFrom).format(DATE_DATA_FORMAT) : ''
      const to = dateTo ? moment(dateTo).format(DATE_DATA_FORMAT) : ''
      onChange([from, to])
    },
    [onChange, setDateFrom]
  )

  const CustomInput = forwardRef(({ value, onClick, onChange }, ref) => (
    <Wrapper className="position-relative">
      <StyledInput
        autoComplete="off"
        value={value}
        onChange={onChange}
        ref={ref}
        placeholder="mm/dd/yyyy"
      /> 
      <CalendarIcon onClick={onClick} />
    </Wrapper>
  ))

  return (
    <>
      <Container>
        <Row>On or After</Row>
        <Row>
          <DatePicker
            dateFormat={'MM/dd/yyyy'}
            isClearable
            customInput={<StyledInput />}
            closeButton
            selected={dateFrom}
            onChange={(date) => handleDateChange([date, dateTo])}
            // onChange={setDateTo}
            showMonthDropdown
            showYearDropdown
            // onChangeRaw={(e) => e.preventDefault()}
            maxDate={dateTo}
            placeholderText="mm/dd/yyyy"
          />
          {/* <DatePicker
            dateFormat={'MM/dd/yyyy'}
            isClearable
            customInput={<CustomInput />}
            closeButton
            selected={dateFrom}
            // onChange={(e) => console.log(e)}
            onChange={(date) => handleDateChange([date, dateTo])}
            // onChange={setDateFrom}
            showMonthDropdown
            showYearDropdown
            // onChangeRaw={(e) => {
            //   e.preventDefault()
            //   console.log(e.target.value)
            //   handleDateChange([e.target.value, dateTo])
            // }}
            // onChangeRaw={(e) => e.preventDefault()}
            maxDate={dateTo}
          /> */}
        </Row>
        <Row>On or Before</Row>
        <Row>
          <DatePicker
            dateFormat={'MM/dd/yyyy'}
            isClearable
            customInput={<StyledInput />}
            closeButton
            selected={dateTo}
            onChange={(date) => handleDateChange([dateFrom, date])}
            // onChange={setDateTo}
            showMonthDropdown
            showYearDropdown
            // onChangeRaw={(e) => e.preventDefault()}
            minDate={dateFrom}
            // maxDate={dateTo}
            placeholderText="mm/dd/yyyy"
          />
        </Row>
      </Container>
    </>
  )
}

export default React.memo(FromToRange)
